// extracted by mini-css-extract-plugin
export var addButton = "_i6-0";
export var border = "_i6-8";
export var check = "_i6-h";
export var danger = "_i6-6";
export var dropdownContainer = "_i6-1";
export var editModalBody = "_i6-j";
export var footerContainer = "_i6-i";
export var fullWidth = "_i6-a";
export var hide = "_i6-9";
export var icon = "_i6-3";
export var input = "_i6-7";
export var inputFlex = "_i6-b";
export var inputWrapper = "_i6-c";
export var manualFocus = "_i6-5";
export var optionButton = "_i6-4";
export var pillWrapper = "_i6-e";
export var pointer = "_i6-2";
export var showOverflow = "_i6-f";
export var tagsFlex = "_i6-d";
export var xButton = "_i6-g";